import RosterBackendService from './RosterBackendService';
import { OrgPermissionDTO, PermissionCode, PermissionDTO, UserRole } from '@beable/roster-backend-client-v1';


async function getPermissionForSiteOrgs(
    siteId: number, permissionCode: PermissionCode, role: UserRole
): Promise<OrgPermissionDTO[]> {
    const response = await RosterBackendService.getPermissionForSiteOrgs({ siteId, permissionCode, role });

    if (response.isOk()) {
        return response.value.orgs;
    }

    return [];
}

async function setPermissionForSiteOrgs(
    siteId: number, permissionCode: PermissionCode, role: UserRole, permissions: PermissionDTO[]
) {
    const response = await RosterBackendService.setPermissionForSiteOrgs({
        siteId,
        permissionCode,
        role,
        permissions
    });
    return response;
}

export default {
    getPermissionForSiteOrgs,
    setPermissionForSiteOrgs
}
